// export default function registerBaseManager(Alpine) {
//   Alpine.data("baseManager", () => ({
//     drawers: {
//       isOpen: false,
//       current: null,
//       data: {},
//     },

//     modals: {
//       isOpen: false,
//       current: null,
//       data: {},
//     },

//     sheets: {
//       isOpen: false,
//       current: null,
//       data: {},
//     },

//     openModal(name, data = {}) {
//       this.closeAll();

//       this.modals.current = name;
//       this.modals.data = data;
//       this.modals.isOpen = true;

//       if (name === "search") {
//         this.$nextTick(() => {
//           setTimeout(() => {
//             this.$refs.searchInput?.focus();
//           }, 100);
//         });
//       }
//     },

//     closeModal() {
//       this.modals.isOpen = false;
//       this.modals.current = null;
//       this.modals.data = {};
//     },

//     openSheet(name, data = {}) {
//       this.closeAll();

//       this.sheets.current = name;
//       this.sheets.data = data;
//       this.sheets.isOpen = true;
//     },

//     closeSheet() {
//       this.sheets.isOpen = false;
//       this.sheets.current = null;
//       this.sheets.data = {};
//     },

//     openDrawer(name, data = {}) {
//       this.closeAll();

//       this.drawers.current = name;
//       this.drawers.data = data;
//       this.drawers.isOpen = true;
//     },

//     closeDrawer() {
//       this.drawers.isOpen = false;
//       this.drawers.current = null;
//       this.drawers.data = {};
//     },

//     closeAll() {
//       this.closeDrawer();
//       this.closeModal();
//       this.closeSheet();
//     },

//     hasOpen() {
//       return this.drawers.isOpen || this.modals.isOpen || this.sheets.isOpen;
//     },
//   }));
// }

// export default function registerBaseManager(Alpine) {
//   Alpine.data("baseManager", () => ({
//     drawers: {
//       isOpen: false,
//       current: null,
//       data: {},
//     },

//     modals: {
//       isOpen: false,
//       current: null,
//       data: {},
//     },

//     sheets: {
//       isOpen: false,
//       current: null,
//       data: {},
//     },

//     // --------------------------------------------------
//     // Internal
//     // --------------------------------------------------

//     _ownsHistory: false,
//     _skipNextPop: false, // set when WE call history.back(), so popstate ignores it
//     _drag: null,

//     init() {
//       // Browser back button
//       this._onPopState = (event) => {
//         // Our own programmatic history.back() — swallow it.
//         if (this._skipNextPop) {
//           this._skipNextPop = false;
//           return;
//         }

//         if (!this.hasOpen()) return;

//         // User popped our entry: the hash is gone, so close everything.
//         if (!window.location.hash) {
//           this._ownsHistory = false;
//           this._closeAllUI();
//           this._cleanupDrag();
//         }
//       };

//       // Escape key
//       this._onKeyDown = (event) => {
//         if (event.key === "Escape" && this.hasOpen()) {
//           this.closeAll();
//         }
//       };

//       // Sheet drag start
//       this._onPointerDown = (event) => {
//         this._dragStart(event);
//       };

//       window.addEventListener("popstate", this._onPopState);
//       window.addEventListener("keydown", this._onKeyDown);

//       this.$root.addEventListener("pointerdown", this._onPointerDown);

//       // Restore from URL hash (deep link / refresh)
//       this.$nextTick(() => {
//         this._restoreFromHash();
//       });
//     },

//     destroy() {
//       window.removeEventListener("popstate", this._onPopState);

//       window.removeEventListener("keydown", this._onKeyDown);

//       this.$root.removeEventListener("pointerdown", this._onPointerDown);

//       this._cleanupDrag();
//     },

//     // --------------------------------------------------
//     // Modal
//     // --------------------------------------------------

//     openModal(name, data = {}) {
//       this._closeAllUI();

//       this.modals.current = name;
//       this.modals.data = data;
//       this.modals.isOpen = true;

//       this._pushHistory("modal", name);

//       if (name === "search") {
//         this.$nextTick(() => {
//           setTimeout(() => {
//             this.$refs.searchInput?.focus();
//           }, 100);
//         });
//       }
//     },

//     closeModal() {
//       this._closeUI("modals");
//       this._removeHash();
//     },

//     // --------------------------------------------------
//     // Sheet
//     // --------------------------------------------------

//     openSheet(name, data = {}) {
//       this._closeAllUI();

//       this.sheets.current = name;
//       this.sheets.data = data;
//       this.sheets.isOpen = true;

//       this._pushHistory("sheet", name);
//     },

//     closeSheet() {
//       this._cleanupDrag();
//       this._closeUI("sheets");
//       this._removeHash();
//     },

//     // --------------------------------------------------
//     // Drawer
//     // --------------------------------------------------

//     openDrawer(name, data = {}) {
//       this._closeAllUI();

//       this.drawers.current = name;
//       this.drawers.data = data;
//       this.drawers.isOpen = true;

//       this._pushHistory("drawer", name);
//     },

//     closeDrawer() {
//       this._closeUI("drawers");
//       this._removeHash();
//     },

//     // --------------------------------------------------
//     // General
//     // --------------------------------------------------

//     closeAll() {
//       this._cleanupDrag();
//       this._closeAllUI();
//       this._removeHash();
//     },

//     hasOpen() {
//       return this.drawers.isOpen || this.modals.isOpen || this.sheets.isOpen;
//     },

//     // --------------------------------------------------
//     // Internal UI Helpers
//     // --------------------------------------------------

//     _closeUI(kind) {
//       const state = this[kind];

//       state.isOpen = false;
//       state.current = null;
//       state.data = {};
//     },

//     _closeAllUI() {
//       this._closeUI("drawers");
//       this._closeUI("modals");
//       this._closeUI("sheets");
//     },

//     // --------------------------------------------------
//     // History
//     // --------------------------------------------------

//     _pushHistory(type, name) {
//       const hash = `#${type}-${name}`;

//       const state = {
//         baseManager: true,
//         type,
//         name,
//       };

//       if (this._ownsHistory) {
//         // Switching overlay while one is open: reuse the entry so a
//         // single back press still returns to the original page state.
//         history.replaceState(state, "", hash);
//       } else {
//         history.pushState(state, "", hash);
//         this._ownsHistory = true;
//       }
//     },

//     _removeHash() {
//       // Programmatic close (X button, backdrop, closeAll, drag-dismiss):
//       // pop the entry we pushed so the stack returns to its original depth
//       // and the back button leaves the page in one press.
//       if (!this._ownsHistory) return;

//       this._ownsHistory = false;
//       this._skipNextPop = true;
//       history.back();
//     },

//     _restoreFromHash() {
//       const hash = window.location.hash.replace("#", "");

//       if (!hash) return;

//       const [type, ...rest] = hash.split("-");
//       const name = rest.join("-");

//       if (!type || !name) return;

//       // Note: only isOpen/current are restored — data isn't in the URL,
//       // so data-driven overlays reopen with empty data.
//       switch (type) {
//         case "modal":
//           this.modals.current = name;
//           this.modals.isOpen = true;
//           break;

//         case "sheet":
//           this.sheets.current = name;
//           this.sheets.isOpen = true;
//           break;

//         case "drawer":
//           this.drawers.current = name;
//           this.drawers.isOpen = true;
//           break;

//         default:
//           return;
//       }

//       this._ownsHistory = true;
//     },

//     // --------------------------------------------------
//     // Sheet Dragging
//     // --------------------------------------------------

//     /*
//       Markup:

//       <div
//         data-sheet
//         x-show="sheets.current === 'filters'"
//       >
//         <div
//           data-draggable
//           class="touch-none"
//         >
//           ...
//         </div>
//       </div>
//     */

//     _dragStart(event) {
//       if (!this.sheets.isOpen) return;
//       if (!event.isPrimary) return;

//       const handle = event.target.closest("[data-draggable]");

//       if (!handle) return;

//       const sheet = handle.closest("[data-sheet]");

//       if (!sheet) return;

//       event.preventDefault();

//       sheet.style.transition = "none";
//       sheet.style.willChange = "transform";

//       this._drag = {
//         sheet,
//         handle,
//         pointerId: event.pointerId,
//         startY: event.clientY,
//         lastY: event.clientY,
//         lastT: performance.now(),
//         velocity: 0,
//         dy: 0,
//       };

//       this._onPointerMove = (e) => this._dragMove(e);

//       this._onPointerUp = (e) => this._dragEnd(e);

//       window.addEventListener("pointermove", this._onPointerMove);

//       window.addEventListener("pointerup", this._onPointerUp);

//       window.addEventListener("pointercancel", this._onPointerUp);
//     },

//     _dragMove(event) {
//       const d = this._drag;

//       if (!d) return;
//       if (event.pointerId !== d.pointerId) return;

//       const now = performance.now();
//       const dt = now - d.lastT;

//       if (dt > 0) {
//         d.velocity = (event.clientY - d.lastY) / dt;
//       }

//       d.lastY = event.clientY;
//       d.lastT = now;

//       let dy = event.clientY - d.startY;

//       // rubber-band upward
//       if (dy < 0) {
//         dy *= 0.15;
//       }

//       d.dy = dy;

//       d.sheet.style.transform = `translateY(${dy}px)`;
//     },

//     _dragEnd(event) {
//       const d = this._drag;

//       if (!d) return;
//       if (event.pointerId !== d.pointerId) return;

//       const height = d.sheet.offsetHeight || 1;

//       const flicked = d.velocity > 0.5 && d.dy > 24;

//       const farEnough = d.dy > height * 0.3;

//       // capture before _cleanupDrag nulls _drag
//       const sheet = d.sheet;

//       sheet.style.transition = "transform 280ms cubic-bezier(0.32, 0.72, 0, 1)";

//       if (flicked || farEnough) {
//         sheet.style.transform = "translateY(100%)";

//         let done = false;

//         const finish = () => {
//           if (done) return;

//           done = true;

//           this.closeSheet();

//           setTimeout(() => {
//             sheet.style.transition = "";
//             sheet.style.transform = "";
//             sheet.style.willChange = "";
//           }, 50);
//         };

//         sheet.addEventListener("transitionend", finish, { once: true });

//         setTimeout(finish, 320);
//       } else {
//         sheet.style.transform = "translateY(0)";

//         setTimeout(() => {
//           sheet.style.transition = "";
//           sheet.style.transform = "";
//           sheet.style.willChange = "";
//         }, 300);
//       }

//       // Drop the move/up listeners now; the leave/snap animation is
//       // self-contained via the captured `sheet` ref.
//       this._cleanupDrag();
//     },

//     _cleanupDrag() {
//       this._drag = null;

//       if (this._onPointerMove) {
//         window.removeEventListener("pointermove", this._onPointerMove);

//         this._onPointerMove = null;
//       }

//       if (this._onPointerUp) {
//         window.removeEventListener("pointerup", this._onPointerUp);

//         window.removeEventListener("pointercancel", this._onPointerUp);

//         this._onPointerUp = null;
//       }
//     },
//   }));
// }

export default function registerBaseManager(Alpine) {
  Alpine.data("baseManager", () => ({
    drawers: {
      isOpen: false,
      current: null,
      data: {},
    },

    modals: {
      isOpen: false,
      current: null,
      data: {},
    },

    sheets: {
      isOpen: false,
      current: null,
      data: {},
    },
    iconSprite: "",

    // --------------------------------------------------
    // Internal
    // --------------------------------------------------

    _ownsHistory: false, // true while WE pushed the current #hash entry
    _skipNextPop: false, // set when WE call history.back(), so popstate ignores it
    _drag: null,

    init() {
      this.iconSprite = this.$el.dataset.staticUrl + "/svgs/dashboard-icons.svg";
      // Browser back button
      this._onPopState = (event) => {
        // Our own programmatic history.back() — swallow it.
        if (this._skipNextPop) {
          this._skipNextPop = false;
          return;
        }

        if (!this.hasOpen()) return;

        // User popped our entry: the hash is gone, so close everything.
        if (!window.location.hash) {
          this._ownsHistory = false;
          this._closeAllUI();
          this._cleanupDrag();
        }
      };

      // Escape key
      this._onKeyDown = (event) => {
        if (event.key === "Escape" && this.hasOpen()) {
          this.closeAll();
        }
      };

      // HTMX history reconcile.
      //
      // When an HTMX request that touches the URL (hx-push-url /
      // hx-replace-url / hx-boost) fires while we own a #hash entry, we
      // collapse our entry in place with replaceState BEFORE HTMX writes
      // its own. This hands the URL off to HTMX so the two history
      // managers don't stack on the same slot.
      //
      // We do NOT close the overlay here — that's left to the caller /
      // afterSwap / an opening modal. After this runs, _ownsHistory is
      // false, so a later closeSheet()->_removeHash() is a history no-op
      // (it early-returns), which is exactly what we want.
      //
      // Inner swaps with no URL-touching attrs are ignored, so the back
      // button still closes the sheet after a harmless in-sheet swap.
      this._onHtmxBeforeRequest = (event) => {
        const elt = event.detail?.elt;
        if (!elt) return;

        const touchesUrl =
          elt.closest("[hx-push-url='true'],[hx-push-url^='/']," + "[hx-replace-url],[hx-boost='true']") != null;

        if (!touchesUrl) return;
        if (!this._ownsHistory) return;

        const url = new URL(window.location.href);
        history.replaceState(history.state, "", url.pathname + url.search);

        this._ownsHistory = false;
      };

      // Sheet drag start
      this._onPointerDown = (event) => {
        this._dragStart(event);
      };

      window.addEventListener("popstate", this._onPopState);
      window.addEventListener("keydown", this._onKeyDown);

      document.body.addEventListener("htmx:beforeRequest", this._onHtmxBeforeRequest);

      this.$root.addEventListener("pointerdown", this._onPointerDown);

      // Restore from URL hash (deep link / refresh).
      // NOTE: on restore the browser created the entry, not us, but we
      // claim _ownsHistory = true so back/close behave consistently.
      // Both the back path and the close path converge correctly.
      this.$nextTick(() => {
        this._restoreFromHash();
      });
    },

    iconHref(name) {
      return `${this.iconSprite}#${name}`;
    },

    destroy() {
      window.removeEventListener("popstate", this._onPopState);
      window.removeEventListener("keydown", this._onKeyDown);

      document.body.removeEventListener("htmx:beforeRequest", this._onHtmxBeforeRequest);

      this.$root.removeEventListener("pointerdown", this._onPointerDown);

      this._cleanupDrag();
    },

    // --------------------------------------------------
    // Modal
    // --------------------------------------------------

    openModal(name, data = {}, opts = {}) {
      this._closeAllUI();

      this.modals.current = name;
      this.modals.data = data;
      this.modals.isOpen = true;

      if (opts.pushHistory === true) {
        this._pushHistory("modal", name);
      }

      if (name === "search") {
        this.$nextTick(() => {
          setTimeout(() => {
            this.$refs.searchInput?.focus();
          }, 100);
        });
      }
    },

    closeModal() {
      this._closeUI("modals");
      this._removeHash();
    },

    // --------------------------------------------------
    // Sheet
    // --------------------------------------------------

    openSheet(name, data = {}, opts = {}) {
      this._closeAllUI();

      this.sheets.current = name;
      this.sheets.data = data;
      this.sheets.isOpen = true;

      if (opts.pushHistory === true) {
        this._pushHistory("sheet", name);
      }
    },

    closeSheet() {
      this._cleanupDrag();
      this._closeUI("sheets");
      this._removeHash();
    },

    // --------------------------------------------------
    // Drawer
    // --------------------------------------------------

    openDrawer(name, data = {}, opts = {}) {
      this._closeAllUI();

      this.drawers.current = name;
      this.drawers.data = data;
      this.drawers.isOpen = true;

      if (opts.pushHistory === true) {
        this._pushHistory("drawer", name);
      }
    },

    closeDrawer() {
      this._closeUI("drawers");
      this._removeHash();
    },

    // --------------------------------------------------
    // General
    // --------------------------------------------------

    closeAll() {
      this._cleanupDrag();
      this._closeAllUI();
      this._removeHash();
    },

    hasOpen() {
      return this.drawers.isOpen || this.modals.isOpen || this.sheets.isOpen;
    },

    // --------------------------------------------------
    // Internal UI Helpers
    // --------------------------------------------------

    _closeUI(kind) {
      const state = this[kind];

      state.isOpen = false;
      state.current = null;
      state.data = {};
    },

    _closeAllUI() {
      this._closeUI("drawers");
      this._closeUI("modals");
      this._closeUI("sheets");
    },

    // --------------------------------------------------
    // History
    // --------------------------------------------------

    _pushHistory(type, name) {
      const hash = `#${type}-${name}`;

      const state = {
        baseManager: true,
        type,
        name,
      };

      if (this._ownsHistory) {
        // Switching overlay while one is open: reuse the entry so a
        // single back press still returns to the original page state.
        history.replaceState(state, "", hash);
      } else {
        history.pushState(state, "", hash);
        this._ownsHistory = true;
      }
    },

    _removeHash() {
      // Programmatic close (X button, backdrop, closeAll, drag-dismiss).
      // Early-return is the off-switch: if HTMX already took the URL
      // (beforeRequest set _ownsHistory = false), we do NOT call back()
      // and clobber HTMX's entry. Keep this guard.
      if (!this._ownsHistory) return;

      this._ownsHistory = false;
      this._skipNextPop = true;
      history.back();
    },

    _restoreFromHash() {
      const hash = window.location.hash.replace("#", "");

      if (!hash) return;

      const [type, ...rest] = hash.split("-");
      const name = rest.join("-");

      if (!type || !name) return;

      // Only isOpen/current are restored — data isn't in the URL,
      // so data-driven overlays reopen with empty data.
      switch (type) {
        case "modal":
          this.modals.current = name;
          this.modals.isOpen = true;
          break;

        case "sheet":
          this.sheets.current = name;
          this.sheets.isOpen = true;
          break;

        case "drawer":
          this.drawers.current = name;
          this.drawers.isOpen = true;
          break;

        default:
          return;
      }

      this._ownsHistory = true;
    },

    // --------------------------------------------------
    // Sheet Dragging
    // --------------------------------------------------

    /*
      Markup:

      <div
        data-sheet
        x-show="sheets.current === 'filters'"
      >
        <div
          data-draggable
          class="touch-none"
        >
          ...
        </div>
      </div>
    */

    _dragStart(event) {
      if (!this.sheets.isOpen) return;
      if (!event.isPrimary) return;

      const handle = event.target.closest("[data-draggable]");
      if (!handle) return;

      const sheet = handle.closest("[data-sheet]");
      if (!sheet) return;

      event.preventDefault();

      sheet.style.transition = "none";
      sheet.style.willChange = "transform";

      this._drag = {
        sheet,
        handle,
        pointerId: event.pointerId,
        startY: event.clientY,
        lastY: event.clientY,
        lastT: performance.now(),
        velocity: 0,
        dy: 0,
      };

      this._onPointerMove = (e) => this._dragMove(e);
      this._onPointerUp = (e) => this._dragEnd(e);

      window.addEventListener("pointermove", this._onPointerMove);
      window.addEventListener("pointerup", this._onPointerUp);
      window.addEventListener("pointercancel", this._onPointerUp);
    },

    _dragMove(event) {
      const d = this._drag;
      if (!d) return;
      if (event.pointerId !== d.pointerId) return;

      const now = performance.now();
      const dt = now - d.lastT;

      if (dt > 0) {
        d.velocity = (event.clientY - d.lastY) / dt;
      }

      d.lastY = event.clientY;
      d.lastT = now;

      let dy = event.clientY - d.startY;

      // rubber-band upward
      if (dy < 0) {
        dy *= 0.15;
      }

      d.dy = dy;
      d.sheet.style.transform = `translateY(${dy}px)`;
    },

    _dragEnd(event) {
      const d = this._drag;
      if (!d) return;
      if (event.pointerId !== d.pointerId) return;

      const height = d.sheet.offsetHeight || 1;
      const flicked = d.velocity > 0.5 && d.dy > 24;
      const farEnough = d.dy > height * 0.3;

      // capture before _cleanupDrag nulls _drag
      const sheet = d.sheet;

      sheet.style.transition = "transform 280ms cubic-bezier(0.32, 0.72, 0, 1)";

      if (flicked || farEnough) {
        sheet.style.transform = "translateY(100%)";

        let done = false;

        const finish = () => {
          if (done) return;
          done = true;

          this.closeSheet();

          setTimeout(() => {
            sheet.style.transition = "";
            sheet.style.transform = "";
            sheet.style.willChange = "";
          }, 50);
        };

        sheet.addEventListener("transitionend", finish, { once: true });
        setTimeout(finish, 320);
      } else {
        sheet.style.transform = "translateY(0)";

        setTimeout(() => {
          sheet.style.transition = "";
          sheet.style.transform = "";
          sheet.style.willChange = "";
        }, 300);
      }

      // Drop the move/up listeners now; the leave/snap animation is
      // self-contained via the captured `sheet` ref.
      this._cleanupDrag();
    },

    _cleanupDrag() {
      this._drag = null;

      if (this._onPointerMove) {
        window.removeEventListener("pointermove", this._onPointerMove);
        this._onPointerMove = null;
      }

      if (this._onPointerUp) {
        window.removeEventListener("pointerup", this._onPointerUp);
        window.removeEventListener("pointercancel", this._onPointerUp);
        this._onPointerUp = null;
      }
    },
  }));
}
